import React from 'react';
import { Box, Button, Card, CardActionArea, CardContent, Container, Grid, Typography } from '@mui/material';
import { Place, Flag } from '@mui/icons-material';
import { Link, useHistory } from 'react-router-dom';
import bannerImg from '../../assets/images/contact-us.png';
import PagePaper from '../../components/Common/PagePaper';
import routes from '../../routes';
import useHasActiveFeatureFlag from '../../hooks/useFeatureFlags';
import { FF_CHAT } from '../../components/FeatureFlagWrapper';

const Banner = () => (
  <Box
    sx={(theme) => ({
      marginBottom: 8,
      [theme.breakpoints.only('xs')]: {
        marginBottom: 2,
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '15vh',
      minHeight: 100,
      padding: '1em',
      boxSizing: 'border-box',
      color: 'white',
      position: 'relative',
      background: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.3)), url(${bannerImg}) no-repeat center center`,
      backgroundSize: 'cover',
    })}
  >
    <Grid
      sx={{
        textShadow: '1px 1px 2px black',
        textAlign: 'center',
        color: '#fff',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <Typography variant="h4">Questions or comments?</Typography>
      </Grid>
      <Grid item>
        <Typography variant="h4">Get in touch</Typography>
      </Grid>
    </Grid>
  </Box>
);

const ContactCard = ({ icon, title, description, onClick = () => {}, hoverShadow = 4, action = true }) => (
  <Card
    variant="outlined"
    sx={{
      height: '100%',
      borderRadius: 2,
      border: '2px solid',
      borderColor: 'primary.main',
      '&:hover': { boxShadow: hoverShadow },
    }}
  >
    {action ? (
      <CardActionArea onClick={onClick} sx={{ height: '100%', p: 3 }}>
        <CardContent sx={{ textAlign: 'center' }}>
          {icon}
          <Typography variant="h5" sx={{ fontWeight: 600, mt: 2, mb: 2 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    ) : (
      <CardContent sx={{ textAlign: 'center' }}>
        {icon}
        <Typography variant="h5" sx={{ fontWeight: 600, mt: 2, mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </CardContent>
    )}
  </Card>
);

const ContactLocalSite = ({ isMobileView }) => {
  const history = useHistory();
  const hasActiveChatFF = useHasActiveFeatureFlag(FF_CHAT);
  // On mobile with chat enabled the card holds its own link + Chat button, so the card itself isn't clickable
  const showChatOptions = isMobileView && hasActiveChatFF;

  return (
    <>
      <Banner />
      <PagePaper>
        <Container maxWidth="md">
          <Grid container spacing={4} justifyContent="center" sx={{ px: { xs: 2, sm: 4 } }}>
            <Grid item xs={12} sm={6}>
              <ContactCard
                icon={<Place color="primary" sx={{ fontSize: 48 }} />}
                title="Contact My Local Site"
                description={
                  showChatOptions
                    ? [
                        'Click ',
                        <Link key="link" to={routes.contactUsLocal}>
                          here
                        </Link>,
                        ' to ask a questions about your rescues, schedule, or site, or provide feedback on a recent experience.',
                        <br key="br" />,
                        <Button
                          key="chat"
                          color="primary"
                          variant="outlined"
                          sx={{ mt: 2, textTransform: 'none', px: 4, fontSize: 18 }}
                          onClick={() => history.push(routes.contactUsChat)}
                        >
                          Chat
                        </Button>,
                      ]
                    : 'Click here to ask a questions about your rescues, schedule, or site, or provide feedback on a recent experience.'
                }
                hoverShadow={showChatOptions ? 0 : 4}
                action={!showChatOptions}
                onClick={() => history.push(routes.contactUsLocal)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ContactCard
                icon={<Flag color="primary" sx={{ fontSize: 48 }} />}
                title="Contact National"
                description="Click here to submit a partnership inquiry, funding opportunity, ask for a press release, or other national-level outreach."
                onClick={() => history.push(routes.contactUsNational)}
              />
            </Grid>
          </Grid>
        </Container>
      </PagePaper>
    </>
  );
};

export default ContactLocalSite;
